module.exports = __webpack_public_path__ + "static/CircularStd-BlackItalic-24799f746654fdca3cf2bcd27672b1d5.ttf";